import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={fill || "currentColor"}
      fillRule="evenodd"
      d="M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Z"
      clipRule="evenodd"
    />
    <path
      fill={fill || "currentColor"}
      d="M13 8a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0V8Z"
    />
    <path
      fill={fill || "currentColor"}
      d="M16 11H8a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2Z"
    />
  </svg>
);
export default SvgComponent;
